import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import { useSvgId } from 'src/hooks';

export const EarthIcon = memo(
  forwardRef((props, ref) => {
    const svgId = useSvgId();

    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 16 16"
        data-fill-none
      >
        <g clipPath={`url(#${svgId})`}>
          <path
            d="M8 14.5625C11.6244 14.5625 14.5625 11.6244 14.5625 8C14.5625 4.37563 11.6244 1.4375 8 1.4375C4.37563 1.4375 1.4375 4.37563 1.4375 8C1.4375 11.6244 4.37563 14.5625 8 14.5625Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.91671 13.1333L4.50004 10.1875H5.13004C5.26309 10.188 5.39444 10.1577 5.51384 10.099C5.63325 10.0403 5.73747 9.95479 5.81837 9.84917C5.90171 9.74598 5.95943 9.62453 5.98681 9.49475C6.01418 9.36497 6.01043 9.23055 5.97587 9.1025L5.53837 7.3525C5.49253 7.16278 5.38416 6.99402 5.23072 6.87339C5.07729 6.75276 4.88772 6.68728 4.69254 6.6875H1.58337"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.25 4.0625H10.87C10.6748 4.06228 10.4852 4.12776 10.3318 4.24839C10.1784 4.36902 10.07 4.53778 10.0242 4.7275L9.58666 6.4775C9.55289 6.60601 9.55009 6.74069 9.57849 6.87049C9.60688 7.00029 9.66566 7.1215 9.75 7.22417C9.8309 7.32979 9.93512 7.41528 10.0545 7.47397C10.1739 7.53266 10.3053 7.56296 10.4383 7.5625H11.36L11.815 10.3333C11.8491 10.5354 11.9531 10.719 12.1087 10.8522C12.2643 10.9855 12.4618 11.0599 12.6667 11.0625H13.8333"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id={svgId}>
            <rect
              width="16"
              height="16"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
